module.exports = __webpack_public_path__ + "static/media/tips2-1.b9b2e7c1.png";